export const SkillsData = [
  {
    type: "Web-Development",
    list: [
      {
        name: "HTML",
        icon: <i class="devicon-html5-plain colored"></i>,
      },
      {
        name: "CSS",
        icon: <i class="devicon-css3-plain colored"></i>,
      },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: "MySQL",
        icon: <i class="devicon-mysql-plain colored"></i>,
      },
    ],
  },
  {
    type: "Programming-Language",
    list: [
      {
        name: "C++",
        icon: <i class="devicon-cplusplus-plain colored"></i>,
      },
      {
        name: "Python",
        icon: <i class="devicon-python-plain colored"></i>,
      },
    ],
  },
  {
    type: "Miscellaneous",
    list: [
      {
        name: "QT",
        icon: <i class="devicon-qt-original colored"></i>,
      },
      {
        name: "Git",
        icon: <i class="devicon-git-plain colored"></i>,
      },
      {
        name: "Linux",
        icon: <i class="devicon-linux-plain colored"></i>,
      },
    ],
  },
];
